

<perfect-scrollbar class="corona-container">
  <div class="container">
    <div class="flex_block" style="height:300px; align-items: center; justify-content: space-between">
      <div class="corona-advice one "  [ngClass]="{'rtl': (langChosen=='ar')?true:false}">
        <img src="assets/img/spring-break/house.svg" alt="">
        <div class="flex_block" style="flex-flow: column">
          <h1>{{language.advice1_title}}</h1>
          <p>{{language.advice1_text}} </p>
        </div>
      </div>
      <div class="corona-advice two" [ngClass]="{'rtl': (langChosen=='ar')?true:false}">
        <img src="assets/img/spring-break/hand-sanitizer.svg" alt="">
        <div class="flex_block" style="flex-flow: column">
          <h1>{{language.advice2_title}}</h1>
          <p>{{language.advice2_text}}</p>
        </div>
      </div>
      <div class="corona-advice three" [ngClass]="{'rtl': (langChosen=='ar')?true:false}">
        <img src="assets/img/spring-break/controller.svg" alt="">
        <div class="flex_block" style="flex-flow: column">
          <h1>{{language.advice3_title}}</h1>
          <p>{{language.advice3_text}}</p>
        </div>
      </div>
    </div>
  </div>
</perfect-scrollbar>

